import React from 'react';
import { useSelector } from 'react-redux';

// Helpers
import * as ReviewsHelpers from 'Shared/model_helpers/Reviews.helper';
import * as ReviewFormHelpers from 'Shared/model_helpers/ReviewForm.helper';

// Utils
import * as ReviewsUtils from 'Shared/utils/Reviews.utils';

// Selectors
import * as ReviewsSelectors from 'Shared/selectors/Reviews.selectors';

// Components
import { WpContainer, WpContainerHeader, WpContainerBody } from 'Wpds/components/container';
import { WpText } from 'Wpds/components/text';
import SharePageQustionResponseItem from './SharePageQustionResponseItem';

type Props = {
  review;
  question;
  showInContainer?: boolean;
  showQuestionHeader?: boolean;
};

const SharePageQuestionItem = ({ review, question, showInContainer = true, showQuestionHeader = true }: Props) => {
  const reviewSlug = ReviewsHelpers.getSlug(review);
  const receiverSlug = ReviewsHelpers.getReceiverSlug(review);

  const allPeerReviewForms = useSelector(state =>
    ReviewsSelectors.getReviewFormsByReviewSlugAndType(state, { reviewSlug, formType: 'peer_review' })
  );

  // Filter so that the receivers self review of themselves always appears as the first review on the page
  const selfReviewForm = allPeerReviewForms.filter(reviewForm => reviewForm.get('userSlug') === receiverSlug);
  const sortedReviewForms = selfReviewForm
    .merge(allPeerReviewForms.filter(reviewForm => reviewForm.get('userSlug') !== receiverSlug))
    .filter(reviewForm => ReviewFormHelpers.getSubmittedAt(reviewForm));

  const baseClassName = 'SharePageQuestionItem';

  const header = <p className={`${baseClassName}__property`}>{ReviewsUtils.generateHeaderForQuestion({ question })}</p>;

  const content = sortedReviewForms
    .valueSeq()
    .map(reviewForm => (
      <SharePageQustionResponseItem
        review={review}
        reviewForm={reviewForm}
        question={question}
        key={`SharePageQuestionItem-${reviewSlug}-${ReviewFormHelpers.getSlug(reviewForm)}`}
      />
    ));

  if (!showInContainer)
    return (
      <>
        {showQuestionHeader && (
          <WpText tag="p" bold>
            {ReviewsUtils.generateHeaderForQuestion({ question })}
          </WpText>
        )}
        {content}
      </>
    );

  return (
    <WpContainer>
      {showQuestionHeader && <WpContainerHeader>{header}</WpContainerHeader>}
      <WpContainerBody>{content}</WpContainerBody>
    </WpContainer>
  );
};

export default SharePageQuestionItem;
